export default "__VITE_ASSET__Bk2l4kyS__"